import { combineReducers } from 'redux'

import library from 'app/store/reducers/ebooks/library.reducer'
import biblioteca from 'app/store/reducers/ebooks/biblioteca.reducer'
import caminos from 'app/store/reducers/ebooks/caminos.reducer'
import texaselar from 'app/store/reducers/ebooks/texaselar.reducer'
import texasslar from 'app/store/reducers/ebooks/texasslar.reducer'

const EbooksReducer = combineReducers({
  library,
  biblioteca,
  caminos,
  texaselar,
  texasslar,
})

export default EbooksReducer
